export const ACCOUNT_DETAILS_TEXT = {
  'account.account_details': {
    'en-GB': 'Account Details',
    'nl-NL': 'Accountgegevens',
  },
  'account.account_details_with_brand': {
    'en-GB': 'Account Details | Moonpig',
    'nl-NL': 'Accountgegevens | Greetz',
  },
  'account.name': {
    'en-GB': 'Name',
    'nl-NL': 'Naam',
  },
  'account.first_name': {
    'en-GB': 'First Name',
    'nl-NL': 'Voornaam',
  },
  'account.last_name': {
    'en-GB': 'Last Name',
    'nl-NL': 'Achternaam',
  },
  'account.password': {
    'en-GB': 'Password',
    'nl-NL': 'Wachtwoord',
  },
  'account.email': {
    'en-GB': 'Email',
    'nl-NL': 'E-mailadres',
  },
  'account.cancel': {
    'en-GB': 'Cancel',
    'nl-NL': 'Annuleren',
  },
  'account.please_reload': {
    'en-GB': 'Please reload the page and try again',
    'nl-NL': 'Laad de pagina opnieuw en probeer het nog eens.',
  },
  'account.edit': {
    'en-GB': 'Edit',
    'nl-NL': 'Bewerken',
  },
  'account.email_sent': {
    'en-GB': 'Email Sent',
    'nl-NL': 'E-mail verstuurd',
  },
  'account.my_account': {
    'en-GB': 'My Account',
    'nl-NL': 'Mijn account',
  },
  'account.something_went_wrong': {
    'en-GB': 'Oops! Something went wrong',
    'nl-NL': 'Oeps! Er ging iets mis',
  },
  'account.email_update_error': {
    'en-GB': 'We were unable to update your emails. Please try again',
    'nl-NL': 'We konden je e-mails niet bijwerken. Probeer het opnieuw',
  },
  'account.email_in_use_error': {
    'en-GB': 'Email address already in use!',
    'nl-NL': 'Het e-mailadres is al in gebruik!',
  },
  'account.email_used_by_other_account': {
    'en-GB':
      'The email address is already being used by another account. Please try entering a new email.',
    'nl-NL':
      'Dit e-mailadres is al in gebruik voor een ander account. Voer een ander e-mailadres in.',
  },
  'account.emails_do_not_match': {
    'en-GB': "Oops, the emails don't match! Please double check.",
    'nl-NL':
      'Oeps, de e-mailadressen komen niet overeen! Controleer het nog eens.',
  },
  'account.updated_name': {
    'en-GB': "We've updated your name!",
    'nl-NL': 'We hebben je naam bijgewerkt!',
  },
  'account.name_has_changed_to': {
    'en-GB': (c: { name: string }) =>
      `Your name has been changed to ${c.name}.`,
    'nl-NL': (c: { name: string }) => `Je naam is veranderd in ${c.name}.`,
  },
  'account.unable_to_update_name': {
    'en-GB': 'We were unable to update your name. Please try again.',
    'nl-NL': 'We konden je naam niet bijwerken. Probeer het opnieuw.',
  },
  'account.update_name': {
    'en-GB': 'Update Name',
    'nl-NL': 'Naam bijwerken',
  },
  'account.update_password': {
    'en-GB': 'Update Password',
    'nl-NL': 'Wachtwoord bijwerken',
  },
  'account.email_update_success': {
    'en-GB': "We've updated your email!",
    'nl-NL': 'We hebben je e-mail bijgewerkt!',
  },
  'account.email_changed_to': {
    'en-GB': (c: { email?: string }) =>
      `Your email has been changed to ${c.email}`,
    'nl-NL': (c: { email?: string }) =>
      `Je e-mail is gewijzigd naar ${c.email}`,
  },
  'account.unable_to_update_email': {
    'en-GB': 'We were unable to update your email. Please try again.',
    'nl-NL': 'We konden je e-mail niet bijwerken. Probeer het opnieuw.',
  },
  'account.new_email': {
    'en-GB': 'New Email',
    'nl-NL': 'Nieuwe e-mail',
  },
  'account.confirm_new_email': {
    'en-GB': 'Confirm New Email',
    'nl-NL': 'Bevestig nieuwe e-mail',
  },
  'account.verify_email': {
    'en-GB': 'Verify Email',
    'nl-NL': 'E-mail verifiëren',
  },
  'account.current_email': {
    'en-GB': 'Current Email',
    'nl-NL': 'Huidige e-mail:',
  },
  'account.update_email': {
    'en-GB': 'Update Email',
    'nl-NL': 'E-mail bijwerken',
  },
}
